<template>
    <div id="main">
        <div class="page">
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('novo-sub-grupo-produto') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        isVenda ? $t('vendas') : $t('promotor')
                                    }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{
                                        isVenda ? $t('produto') : $t('cadastros')
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: isVenda ? 'produtos-subgrupo' : 'subgrupos',
                                            })
                                        "
                                        >{{ $t('sub-grupos-produto') }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        !sgp.idsubgrupoproduto
                                            ? $t('novo-sub-grupo-produto')
                                            : sgp.descricao
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({
                                    name: isVenda ? 'ven-produto-subgrupo' : 'subgrupos',
                                })
                            "
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                ((!isUpdate && permissao.create) ||
                                    (isUpdate && permissao.update)) &&
                                !subgrupoIntegracao
                            "
                            class="save-btn"
                            type="button"
                            @click="salvar()"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit page-container">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="sgp.idsubgrupoprodutoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!sgp.idsubgrupoprodutoerp"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(2)"
                                v-model="sgp.descricao"
                                :placeholder="'descricao-do-sub-grupo-placeholder'"
                                :maxlength="100"
                                :title="'descricao-do-sub-grupo-produto'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!sgp.descricao"
                                ref="descricaoInput"
                                required
                                tooltipLabel="info-descricao-generica"
                            />
                        </div>
                        <div class="column is-4">
                            <vs-select
                                :id="generateId(3)"
                                ref="gpSelect"
                                :title="'grupo-sub-grupo-produto'"
                                :options="grupos"
                                v-model="grupoproduto"
                                :search="loadGrupo"
                                :onChange="updateGrupo"
                                :placeholder="'grupo-do-sub-grupo-placeholder'"
                                :invalid="!sgp.grupoproduto"
                                required
                                tooltipLabel="info-grupo-subgrupoproduto"
                            />
                        </div>
                        <div class="column is-2">
                            <vs-select
                                :id="generateId(4)"
                                ref="situacaoSelect"
                                v-model="situacao"
                                title="situacao"
                                :required="true"
                                :options="situacoes"
                                :searchable="false"
                                :onChange="updateSituacao"
                                :disabled="!isUpdate"
                                tooltipLabel="info-situacao-generica"
                                tooltipPosition="is-left"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubGrupoProdutoService from '@/services/SubGrupoProdutoService';
import GrupoProdutoService from '@/services/GrupoProdutoService';
import SubGrupoValidation from '@/services/validations/SubGrupoValidation';
import Message from '@/models/Message';

export default {
    beforeRouteLeave(to, from, next) {
        if (this.isChanged && this.flag === 0) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    watch: {
        sgp: {
            deep: true,
            handler: function () {
                this.isChanged = true;
            },
        },
    },
    data() {
        return {
            subgrupoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('SUBGRUPOPRODUTO'),
            isSaving: false,
            sgp: {
                situacao: 1,
                idsubgrupoprodutoerp: null,
                grupoproduto: null,
                nomeunico: null,
            },
            editable: false,
            title: '',
            msgs: [],
            grupoproduto: null,
            grupos: [],
            validation: null,
            canSelectGP: false,
            situacao: { label: this.$t('ativo'), id: 1 },
            situacoes: [
                { label: this.$t('ativo'), id: 1 },
                { label: this.$t('inativo'), id: 0 },
            ],
            isUpdate: false,
            // @84561 - Adicionado variável para verificar a origem da rota
            // Esta variável é utilizada sempre que for verificado se a origem da rota é vendas ou promotor
            isVenda: 'vendas' === this.$route.meta.contexto ? true : false,
            empresas: [],
            isChanged: false,
            flag: 0,
        };
    },
    created() {
        if (this.sgp != null && this.sgp != {}) {
            this.editable = true;
        }

        this.service = new SubGrupoProdutoService(this.$http, this.$router);
        this.gruposervice = new GrupoProdutoService(this.$http, this.$router);
        this.validation = new SubGrupoValidation(this.msgs);

        this.permissao = this.isVenda
            ? this.hasPermissionAccess('vendas', 'produtos', 'ven-produto-subgrupo')
            : this.hasPermissionAccess('promotor', 'cadastros', 'subgrupos');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'sub-grupos-produto' },
            });
        } else {
            this.isUpdate = this.$route.params.id ? true : false;
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'sub-grupo-produto' },
                });
            }

            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados(this.$route.params.id);
            }
        }
        this.loadEmpresasId();
        this.loadGrupo('');
    },

    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        carregarDados(id) {
            this.service
                .find(id)
                .then((body) => {
                    if (body.content) {
                        this.sgp = body.content;
                        this.title = this.sgp.descricao;
                        this.getSituacao();
                        if (this.sgp.grupoproduto) {
                            this.grupoproduto = {
                                id: this.sgp.grupoproduto.idgrupoproduto,
                                label: this.sgp.grupoproduto.descricao,
                            };
                        }
                    } else {
                        this.$router.push({
                            name: isVenda ? 'produtos-new-subgrupo' : 'new-subgrupo',
                        });
                    }
                })
                .finally((_) => {
                    this.isChanged = false;
                });
        },
        getSituacao() {
            this.situacao = this.situacoes
                ? this.situacoes.filter((s) => s.id == this.sgp.situacao)[0]
                : this.situacao;
            console.log(this.situacao);
        },
        loadEmpresasId() {
            if (this.$store.state.user.admin) {
                // se for admin, mostra todas as empresas
                this.$store.state.empresas.data.map((e) => {
                    this.empresas.push({ id: `${e.id}` });
                });
            } else {
                // se for cliente, mostra todas as empresas relacionadas a ele
                this.$store.state.user.empresas.map((e) => {
                    this.empresas.push({ id: `${e.id}` });
                });
            }
        },
        loadGrupo(search = '') {
            let empresas = '0, ';
            for (let e of this.empresas) {
                empresas += `${e.id}, `;
            }
            empresas = empresas.slice(0, -2);
            this.gruposervice.findAllComboWithEmpresa(empresas, search).then((body) => {
                this.grupos = [];
                body.content.map((r) => {
                    let grupo = {
                        id: r.idgrupoproduto,
                        label: r.descricao,
                    };
                    this.grupos.push(grupo);
                });
                this.grupos.sort();
                this.grupo = this.grupos[0];
            }, 350);
        },
        salvar(redirect = this.redirectToList) {
            this.flag = 1;
            this.isSaving = true;
            if (this.grupoproduto) {
                this.sgp.grupoproduto = {
                    idgrupoproduto: this.grupoproduto.id,
                };
            }
            this.sgp.situacao = this.situacao.id;
            this.sgp.descricao = this.mapTosave(this.sgp.descricao);
            if (this.validation.validate(this.sgp, this.$refs)) {
                this.service
                    .save(this.sgp)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-subgrupo-produto-salvo';
                            if (this.sgp.id) {
                                msg = 'msg-subgrupo-produto-editado';
                            }
                            this.sgp = body.content;
                            this.msgs.push(new Message('success', msg, true));
                            redirect(2);
                        } else {
                            if (this.$te(body.message)) {
                                let message = body.message;
                                if (message == 'msg-codigo-duplicado-n') {
                                    this.msgs.push(
                                        new Message(
                                            'alert',
                                            this.$t(message, { n: this.sgp.idsubgrupoprodutoerp }),
                                            true,
                                            false
                                        )
                                    );
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                        this.isSaving = false;
                    })
                    .catch((e) => {
                        this.flag = 0;
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                        this.isSaving = false;
                    });
            } else {
                this.isSaving = false;
            }
        },
        redirectToList(time) {
            this.isChanged = false;
            setTimeout(() => {
                this.$router.push({
                    name: this.isVenda ? 'ven-produto-sub-grupo-edit' : 'subgrupos',
                    id: this.sgp.id,
                });
            }, time * 1000 + 50);
        },
        redirectToEdit(time) {
            setTimeout(() => {
                this.$router.push({
                    name: this.isVenda ? 'produtos-edit-subgrupo' : 'edit-subgrupo',
                    params: { id: this.sgp.idsubgrupoproduto },
                });
            }, time * 1000 + 50);
        },
        updateGrupo(gp) {
            if (gp) {
                this.sgp.grupoproduto = gp.id;
                this.grupoproduto = gp;
            } else {
                this.sgp.grupoproduto = null;
                this.grupoproduto = null;
            }
            this.canSelectGP = false;
        },
        updateSituacao(situacao) {
            if (situacao) {
                this.sgp.situacao = situacao.id;
                this.situacao = situacao;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
}
</style>
